import  {
    PRESUPUESTADOR_SAVE_BRANCH_OFFICE,
  } from './constants';
  
  export const saveOwnerBranch = (branchOffice, carLot) => {
    return (dispatch) => {
      dispatch({
        type: PRESUPUESTADOR_SAVE_BRANCH_OFFICE,
        data: {
          branchOffice,
          carLot
        }
      })
    }
  }
  
  export function reducer(state, action) {
    if(action.type === PRESUPUESTADOR_SAVE_BRANCH_OFFICE) {
      return {
        ...state,
        selectedBranchOffice: action.data,
        integration_car_lot_id: action.data.carLot.id,
        integration_car_lot_name: action.data.carLot.name,
        integration_branch_office_id: action.data.branchOffice.id,
        integration_branch_office_name: action.data.branchOffice.name
      }
    }
    return state;
  }
  